module.exports = __webpack_public_path__ + "img/activity-bg4.322803f5.png";